import { AxiosResponse } from 'axios';

import { ApiService } from '@services/api';

import { USER_API_DOMAIN } from '@constants/api';
import { IUpdateMambaProps } from '@domain/interfaces/common/mamba/IMamba';

export class MambaService {
  private readonly apiService: ApiService;

  constructor(baseURL: string) {
    this.apiService = new ApiService(baseURL);
  }

  public updateMambaTerms({ data }: IUpdateMambaProps): Promise<AxiosResponse<void>> {
    return this.apiService.post<void>(`/api/v1/users/mamba-terms-of-service`, {
      ...data,
    });
  }
}

const mambaService = new MambaService(USER_API_DOMAIN);

export default mambaService;
